(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return '';
    return Math.round(n).toLocaleString('cs-CZ') + ' Kč';
  }

  var FALLBACK_COLLECTIONS = [
    { title: 'Balónky a helium', url: '/collections/balonky-a-helium' },
    { title: 'Dekorace', url: '/collections/dekorace' },
    { title: 'Témata oslav', url: '/collections/temata' },
    { title: 'Párty stolování', url: '/collections/party-stolovani' },
    { title: 'Kostýmy', url: '/collections/kostymy' }
  ];

  function productImage(p) {
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    if (p.image) return p.image;
    return '';
  }

  function productCardHtml(p, small) {
    var img = productImage(p);
    var html = '<a class="header-search-suggest__product' + (small ? ' header-search-suggest__product--sm' : '') + '" href="' + p.url + '">';
    html += '<span class="header-search-suggest__product-img">';
    if (img) html += '<img src="' + img + '" alt="" loading="lazy" width="' + (small ? 48 : 140) + '" height="' + (small ? 48 : 140) + '">';
    html += '</span>';
    html += '<span class="header-search-suggest__product-info">';
    html += '<span class="header-search-suggest__product-title">' + escapeHtml(p.title) + '</span>';
    if (p.price) html += '<span class="header-search-suggest__product-price">' + formatPrice(p.price) + '</span>';
    html += '</span></a>';
    return html;
  }

  function renderResults(container, data, query) {
    var results = (data && data.resources && data.resources.results) || {};
    var collections = results.collections || [];
    var queries = results.queries || [];
    var products = results.products || [];

    if (!collections.length && !queries.length && !products.length) {
      container.innerHTML = '<p class="header-search-suggest__empty">Nic jsme nenašli pro „' + escapeHtml(query) + '“</p>';
      container.hidden = false;
      return;
    }

    var topProduct = products.length ? products[0] : null;
    var restProducts = products.length > 1 ? products.slice(1) : [];

    /* Sloupec 1 (fráze/kolekce) je vždy přítomný kvůli konzistentnímu
       vzhledu – pokud pro dotaz nejsou žádné kolekce, doplní se
       oblíbené kolekce jako fallback místo prázdného/chybějícího sloupce. */
    var collectionsToShow = collections.length ? collections : FALLBACK_COLLECTIONS;
    var collectionsLabel = collections.length ? 'Kolekce' : 'Populární kolekce';

    var html = '<div class="hss-grid">';

    /* Column 1 – fráze + kolekce */
    html += '<div class="hss-col hss-col--nav">';
    if (queries.length) {
      html += '<div class="header-search-suggest__section">';
      html += '<p class="header-search-suggest__label">Hledané fráze</p>';
      html += '<ul class="header-search-suggest__queries">';
      queries.forEach(function (q) {
        html += '<li><a href="' + q.url + '">' + (q.styled_text || escapeHtml(q.text)) + '</a></li>';
      });
      html += '</ul></div>';
    }
    html += '<div class="header-search-suggest__section">';
    html += '<p class="header-search-suggest__label">' + collectionsLabel + '</p>';
    html += '<ul class="header-search-suggest__collections">';
    collectionsToShow.forEach(function (c) {
      html += '<li><a href="' + c.url + '">' + escapeHtml(c.title) + '</a></li>';
    });
    html += '</ul></div>';
    html += '</div>';

    /* Column 2 – top produkt */
    if (topProduct) {
      html += '<div class="hss-col hss-col--top">';
      html += '<p class="header-search-suggest__label">Nejoblíbenější</p>';
      html += productCardHtml(topProduct, false);
      html += '</div>';
    }

    /* Column 3 – ostatní produkty */
    if (restProducts.length) {
      html += '<div class="hss-col hss-col--products">';
      html += '<p class="header-search-suggest__label">Produkty</p>';
      html += '<div class="header-search-suggest__products">';
      restProducts.forEach(function (p) {
        html += productCardHtml(p, true);
      });
      html += '</div></div>';
    }

    html += '</div>'; /* /.hss-grid */

    if (products.length) {
      html += '<a class="header-search-suggest__viewall" href="/search?q=' + encodeURIComponent(query) + '">Zobrazit všechny produkty</a>';
    }

    container.innerHTML = html;
    container.hidden = false;
  }

  function setupPredictiveSearch(input, dropdown) {
    if (!input || !dropdown) return;
    var lastQuery = '';

    var runSearch = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) {
        dropdown.hidden = true;
        dropdown.innerHTML = '';
        return;
      }
      lastQuery = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=9' +
        '&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== lastQuery) return;
          renderResults(dropdown, data, q);
        })
        .catch(function () { /* ignore network errors */ });
    }, 220);

    input.addEventListener('input', runSearch);

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && dropdown.innerHTML) dropdown.hidden = false;
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdown.hidden = true;
    });

    document.addEventListener('click', function (e) {
      if (e.target !== input && !dropdown.contains(e.target)) {
        dropdown.hidden = true;
      }
    });
  }

  function init() {
    setupPredictiveSearch(
      document.getElementById('HeaderSearchInput'),
      document.getElementById('HeaderSearchSuggest')
    );
    setupPredictiveSearch(
      document.getElementById('MobileSearchInput'),
      document.getElementById('HeaderSearchSuggestMobile')
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
